import Operators from "../pages/Operators/Operators";
import AddOperator from "../containers/AddOperator/AddOperator";
import OperatorLayout from "../layout/OperatorLayout";
import OperatorProfile from "../containers/OperatorProfile/OperatorProfile";
import OperatorWallet from "../containers/Wallet/OperatorWallet";
import AssignCoverOperator from "../containers/AssignCoverOperator/AssignCoverOperator";
import Commission from "../containers/Commission/Commission";
import OperatorPayments from "../containers/Payments/Payments";
import OperatorIssuedPolicies from "../containers/PoliciesIssued/PoliciesIssued";
import TripDetails from "../../issuance/containers/TripTravellerDetail/TripDetails";
import QRCode from "../containers/QRCode/QRCode";
import AddOperatorLink from "../containers/AddOperatorLink/AddOperatorLink";
import AccountExpiry from "../containers/AccountExpiry/AccountExpiry";
// import OperatorOverview from "../containers/OperatorOverview/OperatorOverview";

// Always use OperatorLayout regardless of role
const commonRoutes = [
  // { path: "overview", element: <OperatorOverview /> },
  { path: "operator-profile", element: <OperatorProfile /> },
  { path: "wallet", element: <OperatorWallet /> },
  { path: "operator-assign-covers", element: <AssignCoverOperator /> },
  { path: "commission", element: <Commission /> },
  { path: "operator-payments", element: <OperatorPayments /> },
  { path: "policies-issued", element: <OperatorIssuedPolicies /> },
  { path: "policies-issued/:id", element: <TripDetails /> },
  { path: "qr-code", element: <QRCode /> },
  { path: "qr-code/add", element: <AddOperatorLink /> },
  { path: "account-expiry", element: <AccountExpiry /> },
];

const OperatorRoutes = [
  { path: "operator/operators/", element: <Operators /> },
  { path: "operator/operators/create", element: <AddOperator /> },
  {
    path: "operator/operators/:uuid",
    element: <OperatorLayout />,
    children: commonRoutes,
  },
];

export default OperatorRoutes;